import { render } from "./PasswordChangeCard.vue?vue&type=template&id=c3c1fb38"
import script from "./PasswordChangeCard.vue?vue&type=script&lang=js"
export * from "./PasswordChangeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__